var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4385 8.70124C14.7784 8.84206 15.0001 9.1738 15.0001 9.54177L15.0001 20.4592C15.0001 20.8272 14.7784 21.159 14.4385 21.2998C14.0985 21.4406 13.7072 21.3628 13.447 21.1026L10.0743 17.7299H7.7218C7.21934 17.7299 6.81201 17.3225 6.81201 16.8201V13.1809C6.81201 12.6785 7.21934 12.2711 7.7218 12.2711H10.0743L13.447 8.89845C13.7072 8.63826 14.0985 8.56042 14.4385 8.70124Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2369 8.56725C19.5922 8.21196 20.1682 8.21196 20.5235 8.56725C22.1689 10.2127 23.1882 12.4884 23.1882 15.0004C23.1882 17.5125 22.1689 19.7882 20.5235 21.4336C20.1682 21.7889 19.5922 21.7889 19.2369 21.4336C18.8816 21.0783 18.8816 20.5023 19.2369 20.147C20.555 18.8289 21.3686 17.0105 21.3686 15.0004C21.3686 12.9903 20.555 11.172 19.2369 9.85389C18.8816 9.49859 18.8816 8.92255 19.2369 8.56725ZM16.6636 11.1405C17.0189 10.7852 17.5949 10.7852 17.9502 11.1405C18.4287 11.619 18.8191 12.1864 19.0944 12.8166C19.3871 13.4865 19.549 14.2258 19.549 15.0004C19.549 16.5076 18.9371 17.8735 17.9502 18.8603C17.5949 19.2156 17.0189 19.2156 16.6636 18.8603C16.3083 18.505 16.3083 17.929 16.6636 17.5737C17.3231 16.9141 17.7295 16.0056 17.7295 15.0004C17.7295 14.4812 17.6213 13.9896 17.4271 13.5451C17.2439 13.1259 16.9836 12.7472 16.6636 12.4272C16.3083 12.0719 16.3083 11.4958 16.6636 11.1405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound_on.9f0e16d84ff626099b932425940e46e7.svg";
export { ForwardRef as ReactComponent };